import { appThemeApiRef, useApi } from "@backstage/core-plugin-api";
import { useTheme } from "@material-ui/core/styles";

export const useThemeSettings = (): string => {
  const appThemeApi = useApi(appThemeApiRef);
  const themeId = appThemeApi.getActiveThemeId();
  const themeManifest = useTheme<any>();
  let theme: any = themeId;
  if (!theme) {
    theme = themeManifest.id;
  }
  return theme;
};
